import React, { FC } from "react";
import { NewsArticleContainerDoctor } from "../DoctorsContainer/NewsArticleContainerDoctor.csharp";

export const NewsArticleDoctorCard: FC<NewsArticleContainerDoctor> = ({
  fullName,
  url,
  imageUrl,
  jobTitle,
  centers,
}) => {
  return (
    <div className="card card-hover theme-inherit-light">
      <div className="card-body">
        <div className="d-flex">
          <img
            className="circular-image medium me-2"
            src={
              imageUrl +
              "?width=216&height=216&rmode=crop&ranchor=top"
            }
            loading="lazy"
          />
          <div className="lh-sm">
            <h3 className="h5">
              <a className="card-block-link" href={url}>
                {fullName}
              </a>
            </h3>
            {jobTitle && <p className="fw-bold">{jobTitle}</p>}
            {centers && <p>{centers.join(", ")}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};
